// extracted by mini-css-extract-plugin
export default {"codeBlock":"CodeBlock_codeBlock__GQsBl","start":"CodeBlock_start__L3M1+","end":"CodeBlock_end__y-4O+"};